"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withTooltipHelpIcon;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _HelpIconWrapper = _interopRequireDefault(require("../../component/HelpIconWrapper"));

var _Strings = require("@phg/stilo-utils/Strings");

function withTooltipHelpIcon(WrappedComponent) {
  var WithTooltipHelpIcon = function WithTooltipHelpIcon(_ref) {
    var tooltip = _ref.tooltip,
        tooltipPlacement = _ref.tooltipPlacement,
        tooltipOffset = _ref.tooltipOffset,
        tooltipClassName = _ref.tooltipClassName,
        tooltipPositionHorizontal = _ref.tooltipPositionHorizontal,
        tooltipPositionVertical = _ref.tooltipPositionVertical,
        tooltipArrowOffset = _ref.tooltipArrowOffset,
        iconClassName = _ref.iconClassName,
        className = _ref.className,
        tooltipSize = _ref.tooltipSize,
        rest = (0, _objectWithoutProperties2["default"])(_ref, ["tooltip", "tooltipPlacement", "tooltipOffset", "tooltipClassName", "tooltipPositionHorizontal", "tooltipPositionVertical", "tooltipArrowOffset", "iconClassName", "className", "tooltipSize"]);

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        open = _useState2[0],
        setOpen = _useState2[1];

    var _useState3 = (0, _react.useState)(null),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        timer = _useState4[0],
        setTimer = _useState4[1];

    var handleOpen = function handleOpen() {
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }

      setOpen(true);
    };

    var handleClose = function handleClose() {
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }

      setTimer(setTimeout(function () {
        setOpen(false);
      }, 150));
    };

    if (!tooltip) {
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, rest);
    }

    return /*#__PURE__*/_react["default"].createElement(_HelpIconWrapper["default"], {
      id: (0, _Strings.suffixIfSubject)(rest.id, '-help'),
      tooltip: tooltip,
      tooltipOffset: tooltipOffset,
      tooltipPlacement: tooltipPlacement,
      tooltipClassName: tooltipClassName,
      tooltipPositionHorizontal: tooltipPositionHorizontal,
      tooltipPositionVertical: tooltipPositionVertical,
      tooltipArrowOffset: tooltipArrowOffset,
      iconClassName: iconClassName,
      className: className,
      tooltipOpen: open,
      onIconClick: handleOpen,
      onOutsideClick: handleClose,
      onIconEnter: handleOpen,
      onIconLeave: handleClose,
      tooltipSize: tooltipSize
    }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, rest));
  };

  return WithTooltipHelpIcon;
}
//# sourceMappingURL=index.js.map